.root {
  width: 100%;
  height: 100%;
}

.creative {
  max-width: none;
  max-height: none;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform-origin: 0 0;
  transform: var(--ad-offset, translate(0)) scale(var(--ad-scale, 1));
  transition:
    transform 0.1s ease-out,
    opacity 0.25s ease-in-out;
  z-index: 1;
}

.noPointerEvents {
  pointer-events: none;
}

.imageNotLoaded {
  opacity: 0;
}

.imageLoaded {
  opacity: 1;
}
